import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3590edde&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MediaSubNav: require('/app/components/media-sub-nav.vue').default,MediaMobileNav: require('/app/components/media-mobile-nav.vue').default,VideoGallary1: require('/app/components/video-gallary-1.vue').default,SocialWall: require('/app/components/social-wall.vue').default})
